'use strict';

var inherits = require('inherits')
  , XhrDriver = require('../driver/xhr')
  ;

function XHRLocalObject(method, url, payload /*, opts */) {
  XhrDriver.call(this, method, url, payload, {
    noCredentials: true
  });
}

inherits(XHRLocalObject, XhrDriver);

XHRLocalObject.enabled = XhrDriver.enabled;

module.exports = XHRLocalObject;



/*****************
 ** WEBPACK FOOTER
 ** ./~/sockjs-client/lib/transport/sender/xhr-local.js
 ** module id = 68
 ** module chunks = 0
 **/